import React, { forwardRef } from 'react';
import { clsx } from 'clsx';

const Input = forwardRef(({
  label,
  error,
  helperText,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  onRightIconClick,
  className = '',
  fullWidth = true,
  ...props
}, ref) => {
  const inputClasses = clsx(
    'block px-4 py-3 border-2 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-0 sm:text-sm transition-all duration-300 bg-white/90 backdrop-blur-sm',
    {
      'border-gray-200 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-300': !error,
      'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': error,
      'pl-12': LeftIcon,
      'pr-12': RightIcon,
      'w-full': fullWidth,
    },
    className
  );

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative group">
        {LeftIcon && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none transition-colors duration-300 group-focus-within:text-blue-500">
            <LeftIcon className="h-5 w-5 text-gray-400" />
          </div>
        )}
        <input
          ref={ref}
          className={inputClasses}
          {...props}
        />
        {RightIcon && (
          <div 
            className={clsx(
              'absolute inset-y-0 right-0 pr-4 flex items-center transition-colors duration-300',
              {
                'cursor-pointer hover:text-blue-500 group-focus-within:text-blue-500': onRightIconClick,
                'pointer-events-none group-focus-within:text-blue-500': !onRightIconClick,
              }
            )}
            onClick={onRightIconClick}
          >
            <RightIcon className="h-5 w-5 text-gray-400" />
          </div>
        )}
      </div>
      {(error || helperText) && (
        <p className={clsx(
          'mt-2 text-sm',
          {
            'text-red-600': error,
            'text-gray-500': !error && helperText,
          }
        )}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input; 